import { render } from "./main.vue?vue&type=template&id=c6ed0f2a&ts=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=c6ed0f2a&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__